<template>
  <SfButton
    v-bind="$attrs"
    :size="size"
    :variant="variant"
    :disabled="disabled"
    :square="square"
    :tag="tag"
    tabindex="0"
    class="mobile:!text-base mobile:!leading-8"
    :class="{ '!text-neutral-900 hover:!bg-neutral-100': variant === 'secondary' || color === 'neutral',
              '!text-primary-700 hover:!bg-primary-100': color === 'primary',
              '!bg-neutral-900 !text-white hover:!bg-neutral-950 disabled:!bg-disabled-300/50 disabled:!text-disabled-500/50': color === 'grey',
              '!bg-disabled-300': disabled,
              '!uppercase': uppercase }"
  >
    <slot />
  </SfButton>
</template>

<script lang="ts" setup>
import { SfButton } from '@storefront-ui/vue';

interface Props {
  size?: 'base' | 'sm' | 'lg';
  variant?: 'primary' | 'secondary' | 'tertiary';
  disabled?: boolean;
  square?: boolean;
  tag?: string;
  color?: 'primary' | 'neutral' | 'grey' | undefined;
  uppercase?: boolean;
}

withDefaults(defineProps<Props>(), {
  variant: 'primary',
  size: 'base',
  color: undefined,
  uppercase: false,
});
</script>
